import axios from "../api/api"
import { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";

const GETDATABYID = "/api/vartman"

const VartmanModal = ({ show, setShow, id, setId }) => {
    const [data, Setdata] = useState([])

    useEffect(() => {
        const getdatabyid = async () => {
            if(show === true) {
                const response = await axios.get(`${GETDATABYID}/${id}`)
                
              Setdata(response.data.vartmanchaubisi)

            }else {
             
                Setdata([])
            }
        }
        getdatabyid()
    }, [id])

    // Handle hide
    const handleHide = () => {
        setId(null);
        setShow(false);
    }



    return (
        <Modal show={show} onHide={handleHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>जैन धर्म तीर्थंकर -{data?.hindititle} </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table bordered striped hover>
                    <tbody>
                        <tr>
                            <th>नाम</th>
                            <td>{data?.hindititle}</td>
                        </tr>
                        <tr>
                            <th>चिन्ह </th>
                            <td>{data?.hindipratik}</td>
                        </tr>
                        <tr>
                            <th>पिता का नाम</th>
                            <td>{data?.introfather}</td>
                        </tr>
                        <tr>
                            <th>माता का नाम</th>
                            <td>{data?.intromother}</td>
                        </tr>
                        <tr>
                            <th className="w-20">जीवन परिचय</th>
                            <td>{data?.content}</td>
                        </tr>
                        <tr>
                            <th className="w-20">गर्भ तिथि </th>
                            <td>{data?.garbhtithi}</td>
                        </tr>
                        <tr>
                            <th className="w-20">गर्भ स्थान </th>
                            <td>{data?.garbhplace}</td>
                        </tr>
                        <tr>
                            <th className="w-20">जन्म तिथि </th>
                            <td>{data?.janmtithi}</td>
                        </tr>
                        <tr>
                            <th className="w-20">जन्म स्थान </th>
                            <td>{data?.janmplace}</td>
                        </tr>
                        <tr>
                            <th className="w-20">वंश  </th>
                            <td>{data?.introkull}</td>
                        </tr>
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    )
}

export default VartmanModal;